import Tooltip from "components/global/tooltip"
import { CopyButtonWithSuccess } from "components/ui/copy-button-with-success"

import cn from 'classnames'

import styles from './styles.module.scss'
import { formatAddress, formatCurrency, formatTag } from "utils/formatters"
import { useTranslation } from "utils/use-translation"
import ConfirmDataProps from "./index.props"
import { NetworkLabel } from "components/ui/network-label"

const ConfirmData = ({ currencyInfo, address, hasTag, tag, className }: ConfirmDataProps) => {
    const { t } = useTranslation()

    return (
        <section className={cn(styles.confirm__data, className)}>
            <div className={styles.confirm__item}>
                <span className={styles.confirm__item__label}>{t('currency')}</span>
                <div className={cn(styles.confirm__item__value, styles.confirm__coin)}>
                    {currencyInfo && (
                        <>
                            <img
                                alt={currencyInfo?.code}
                                src={currencyInfo?.logo_url}
                                width={24}
                                height={24}
                            />
                            <div className={styles.confirm__ticker}>{formatCurrency(currencyInfo, true)}</div>
                            <NetworkLabel currency={currencyInfo} className={styles['confirm__network-label']} />
                        </>
                    )}
                </div>
            </div>

            <div className={styles.confirm__item}>
                <span className={styles.confirm__item__label}>{t('address')}</span>
                <div className={cn(styles.confirm__item__value, styles['has-tooltip'])}>
                    <span>{formatAddress(address, 8)}</span>

                    {address && (
                        <>
                            <Tooltip className={styles.tooltip}>
                                <span>{address}</span>
                            </Tooltip>

                            <CopyButtonWithSuccess value={address} className={styles.btn__copy} />
                        </>
                    )}
                </div>
            </div>

            {hasTag && tag && <div className={styles.confirm__item}>
                <span className={styles.confirm__item__label}>{t('tag_subtitle')}</span>
                <div className={cn(styles.confirm__item__value, styles['has-tooltip'])}>
                    <span>{formatTag(tag)}</span>

                    {tag.length > 12 && <Tooltip className={styles.tooltip}>
                        <span>{tag}</span>
                    </Tooltip>}

                    <CopyButtonWithSuccess value={tag} className={styles.btn__copy} />
                </div>
            </div>}
        </section>
    )
}

export default ConfirmData